import {
  CREATE_BRANCH_START,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAILED,

  UPDATE_BRANCH_START,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAILED,
  DELETE_BRANCH_START,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAILED,
  FETCH_BRANCHES_START,
  FETCH_BRANCHES_SUCCESS,
  FETCH_BRANCHES_FAILED,

  FETCH_USERS_BRANCHES_START,
  FETCH_USERS_BRANCHES_SUCCESS,
  FETCH_USERS_BRANCHES_FAILED,

  CLEAR_BRANCH_ERROR
} from "../store/types";

import {//
  cloud_function_server_url,
} from "config";

export const clearBranchErrors = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_BRANCH_ERROR,
    payload: null,
  });
};

export const createBranch = (officeData) => (dispatch) => async (firebase) => {
  dispatch({
    type: CREATE_BRANCH_START,
    payload: null,
  });

  if (!officeData) {
    console.error("Error: No data provided");
    dispatch({
      type: CREATE_BRANCH_FAILED,
      payload: "error: no branch data provided",
    });
    return;

  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "officeData": {
      "BranchName": officeData.BranchName,
      "manager": officeData.manager,
      "Province": officeData.Province,
      "contactInfo": officeData.contactInfo,
      "address": officeData.address,
      "admin": officeData.admin,
    }
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  try {


    const response = await fetch(`${cloud_function_server_url}/create_Branch`, requestOptions);

    if (!response.ok) {

      const errorMessage = await response.text();
      dispatch({
        type: CREATE_BRANCH_FAILED,
        payload: `HTTP error! status: ${response.status}, message: ${errorMessage}`,
      });
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorMessage}`);
    }

    const result = await response.json(); // Assuming the response is in JSON format
    console.log("results", result);


    dispatch({ type: CREATE_BRANCH_SUCCESS, payload: result });


    return { success: true, message: "Branch was created!!" };

  } catch (error) {
    console.error("Error creating branch:", error);


    //dispatch({ type: CREATE_BRANCH_FAILED, payload: error.message });

    return { success: false, message: error.message };
  }
};
export const updateBranch = (officeData) => (dispatch) => async (firebase) => {
  // Start the update process
  dispatch({
    type: UPDATE_BRANCH_START,
    payload: null,
  });

  // Validate input data
  if (!officeData) {
    console.error("Error: No data provided");
    dispatch({
      type: UPDATE_BRANCH_FAILED,
      payload: "Error: No branch data provided",
    });
    return;
  }

  // Set up headers
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  // Prepare the payload
  const raw = JSON.stringify({
    officeData: {
      branchId: officeData.branchId,
      BranchName: officeData.BranchName,
      manager: officeData.manager,
      Province: officeData.Province,
      contactInfo: officeData.contactInfo,
      address: officeData.address,
      admin: officeData.admin,
    },
  });

  // Configure the request
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    // Make the API call


    const response = await fetch(
      `${cloud_function_server_url}/updateBranch`,
      requestOptions
    );

    // Parse response
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log("Update successful:", result);

    // Dispatch success action
    dispatch({
      type: UPDATE_BRANCH_SUCCESS,
      payload: result,
    });
  } catch (error) {
    console.error("Error updating branch:", error);

    // Dispatch failure action
    dispatch({
      type: UPDATE_BRANCH_FAILED,
      payload: error.message,
    });
  }
};

export const deleteBranch = (officeData) => (dispatch) => async (firebase) => {
  // Start the delete process
  dispatch({
    type: DELETE_BRANCH_START,
    payload: null,
  });

  // Validate input data
  if (!officeData || !officeData.branchId) {
    console.error("Error: No branch data provided");
    dispatch({
      type: DELETE_BRANCH_FAILED,
      payload: "Error: No branch data provided",
    });
    return;
  }

  // Set up headers
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  // Prepare the payload
  const raw = JSON.stringify({
    officeData: {
      branchId: officeData.branchId,
    },
  });

  // Configure the request
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    // Make the API call

    const response = await fetch(
      `${cloud_function_server_url}/removeBranch`,
      requestOptions
    );

    // Check for a successful response
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log("Branch removed successfully:", result);

    // Dispatch success action with the branch ID
    dispatch({
      type: DELETE_BRANCH_SUCCESS,
      payload: branchData.branchId,
    });
  } catch (error) {
    console.error("Error removing branch:", error);

    // Dispatch failure action with a user-friendly message
    dispatch({
      type: DELETE_BRANCH_FAILED,
      payload: error.message || "An unexpected error occurred while deleting the branch.",
    });
  }
};

export const fetchAllBranches = () => (dispatch) => async (firebase) => {
  const { auth } = firebase;


  dispatch({
    type: FETCH_BRANCHES_START,
    payload: null,
  });

  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  try {

    const response = await fetch(
      `${cloud_function_server_url}/getBranches`,
      requestOptions
    );

    if (!response.ok) {
      const errorMessage = await response.text();
      dispatch({
        type: FETCH_BRANCHES_FAILED,
        payload: `HTTP error! Status: ${response.status}, message: ${errorMessage}`,
      });
      throw new Error(`HTTP error! Status: ${response.status}, message: ${errorMessage}`);
    }


    const result = await response.json();
    console.log("Fetched Data:", result);



    let userBranch = result.branches.filter((x) => x.BranchName === auth?.profile?.currentUser?.adminHomeOffice);

    console.log('userBranch', userBranch)


    if (userBranch && result.branches) {
      console.log('here')
      dispatch({ type: FETCH_USERS_BRANCHES_SUCCESS, payload: userBranch });
      dispatch({ type: FETCH_BRANCHES_SUCCESS, payload: result.branches });

      return { success: true, data: result };
    }









  } catch (error) {
    console.error("Error fetching branches:", error);


    dispatch({ type: FETCH_BRANCHES_FAILED, payload: error.message });


    return { success: false, message: error.message };
  }
};

export const get_Branch_By_Name = (branchData) => (dispatch) => async (firebase) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "branchData": {
      "BranchName": branchData.BranchName
    }
  });

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch("http://127.0.0.1:5002/api-nexus-f7bcd/us-central1/getBranchByName", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
};
